export const PANEL_VIEWPORT_GAP = 0;
export const LEFT_PANEL_WIDTH = 380;
export const CLOSED_DRAWER_OFFSET = 57;

export const drawerWidth = 280;
export const appBarHeight = 66;
export const closedDrawerWidth = (theme) => `calc(${theme.spacing(7)} + 1px)`;
